// Helper to normalize a recurring string to a concise, human-readable form

import { TaskRecurring } from "@demind-inc/core";

/**
 * Normalizes the human-readable recurrence string coming from demind-inc-core.
 * We simply lower-case it and strip any trailing time fragments (e.g., "at 12:50pm").
 */
export const normalizeRecurringString = (recurring?: TaskRecurring): string | null => {
  if (!recurring?.isRecurring || !recurring.string) {
    return null;
  }

  return recurring.string
    .toLowerCase()
    .replace(/\s+at\s+\d{1,2}:\d{2}\s*(am|pm)?/i, '')
    .trim();
};

/**
 * Checks if a recurrence string is custom (not parseable to standard options)
 */
export const isCustomRecurrence = (recurrenceText: string | null): boolean => {
  if (!recurrenceText) return false;

  const normalized = recurrenceText.toLowerCase().trim();

  // Check for standard patterns
  if (normalized === 'every day') return false;
  if (normalized === 'every weekday') return false;
  if (/^every (mon|tue|wed|thu|fri|sat|sun|monday|tuesday|wednesday|thursday|friday|saturday|sunday)$/.test(normalized)) return false;
  if (/^every \d{1,2}(st|nd|rd|th)$/.test(normalized)) return false;
  if (/^every \d{1,2}(st|nd|rd|th) (jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)$/.test(normalized)) return false;

  return true;
};